import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  absolute: {
    position: "absolute",
  },
  drawer: {
    zIndex: 2000,
  },
  alignCenter: {
    textAlign: "center",
  },
  drawerBody: {
    margin: "30px 40px",
  },
  drawerActions: {
    padding: 13,
  },
}));
